import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = `orgPersona`
const plural = 'orgPersonas'
const single = 'orgPersona'

const api = new ApiCore({
	index: true,
	remove: true,
	create: true,
	url: url,
	plural: plural,
	single: single
})

api.deletePersona = (resource) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}`, {data: resource})
		.then(handleResponse)
		.catch(handleError);
}

api.enablePersona = (params) => {
	return axios
		.put(`${apiProvider.BASE_URL}/orgUseCase`, params)
		.then(handleResponse)
		.catch(handleError);
}

export default api
